import { useContext } from 'react';
import DatePicker from '@components/FormFields/DatePicker';
import DashboardContext from '@/layouts/DashboardLayout/DashboardContext';

type Props = {
  value: string | null;
  onChange: (newDate: string | null) => void;
};

const FirstPaymentDatePicker: React.FC<Props> = ({ value, onChange }) => {
  const { isInDashboard } = useContext(DashboardContext);

  const giveMinDate = (): string => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow.toISOString().split('T')[0];
  };

  const giveMaxDate = (): string => {
    const maxDate = new Date();
    maxDate.setMonth(maxDate.getMonth() + (isInDashboard ? 6 : 2));
    return maxDate.toISOString().split('T')[0];
  };

  return (
    <DatePicker
      min={giveMinDate()}
      max={giveMaxDate()}
      value={value}
      onChange={onChange}
      label='First Payment Date'
    />
  );
};

export default FirstPaymentDatePicker;
